// A conservative routing hint. The server rechecks the complete stored copy,
// including history omitted from file-list responses, before any recovery.
export const SPREADSHEET_IMPORT_VERSION = 3;

export function mayNeedSpreadsheetImportRecovery(file) {
  const params = file?.parameters;
  return Boolean(params?.source === 'editor-import' && params.importedFromFileId
    && !['spreadsheet-csv', 'spreadsheet-tsv'].includes(params.importedFromKind)
    && Number(params.spreadsheetImportVersion || 0) < SPREADSHEET_IMPORT_VERSION
    && Number(params.spreadsheetRevision || 0) === 0 && Number(params.revisionIndex || 0) === 0
    && !params.lastEditedAt && !params.lastAiRevisionAt && !params.lastRestoredAt
    && !params.revisionHistory?.length && Array.isArray(params.spreadsheetSpec?.sheets));
}

export const SAVED_CHART_NOTICE = 'Saved chart: cell links could not be verified. This chart may not reflect changes to the workbook.';

// Older imports did not record the selected series columns. Never infer those
// links from current headers/values: edits may have changed them. Mark only
// imported charts; charts the user subsequently inserted have their own links.
export function spreadsheetSpecForFile(file, spec = file?.parameters?.spreadsheetSpec) {
  if (file?.parameters?.source !== 'editor-import' || Number(file.parameters.spreadsheetImportVersion || 0) >= 1
    || !Array.isArray(spec?.sheets)) return spec;
  let changed = false;
  const sheets = spec.sheets.map(sheet => {
    if (!Array.isArray(sheet?.charts)) return sheet;
    let changedSheet = false;
    const charts = sheet.charts.map(chart => {
      if (!/^imported-chart-\d+$/.test(chart?.id || '') || chart.sourceRangeStatus === 'unverified'
        || chart.sourceRange?.seriesColumns !== undefined) return chart;
      const { sourceRange, ...snapshot } = chart;
      changed = true; changedSheet = true;
      return { ...snapshot, sourceRangeStatus: 'unverified' };
    });
    return changedSheet ? { ...sheet, charts } : sheet;
  });
  return changed ? { ...spec, sheets } : spec;
}
